module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('logo', {
    staticStyle: {
      "text-align": "center"
    }
  })], 1), _vm._v(" "), _c('form', {
    staticClass: "mdl-cell mdl-cell--12-col-phone mdl-cell--6-col-tablet",
    staticStyle: {
      "margin": "0 auto"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('mdl-textfield', {
    staticClass: "mdl-cell mdl-cell--12-col",
    attrs: {
      "label": "Login",
      "autofocus": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('mdl-textfield', {
    staticClass: "mdl-cell mdl-cell--12-col",
    attrs: {
      "label": "Hasło",
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-cell mdl-cell--12-col",
    attrs: {
      "primary": "",
      "disabled": _vm.logging
    }
  }, [(_vm.logging) ? [_vm._v("Logowanie...")] : [_vm._v("Zaloguj")]], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33945ee4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 261
// module chunks = 1